import {
	registerPageContextProvider,
	registerSuggestionsProvider,
} from '@/features/ai/registry'

import { getSearchBubbles } from './constants'
import { useSearchPageContext } from './hooks/use-search-page-context'

/**
 * Side-effect registration for AIR® AI bindings on the `/search` route.
 *
 * Side-effect imported by `src/routes/_dashboard/search.index.tsx`.
 * Registers under `'search_overview'` (the literal returned by
 * `useSearchPageContext`).
 *
 * "Open in Search" navigation is no longer routed through the registry —
 * `<OpenInSearchCard>` resolves it inline via `useNavigate()`.
 */

registerPageContextProvider('search_overview', useSearchPageContext)
registerSuggestionsProvider('search_overview', getSearchBubbles)
